import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { from, Observable } from 'rxjs';
import { ComponentBase, OrderCustomerModel, CustomerType, CustomerInfo } from 't4core';

@Component({
  selector: 'new-company-dialog',
  templateUrl: 'NewCompanyDialog.html',
})
export class NewCompanyDialog extends ComponentBase {

  public customerNumber: string;
  public isLoading: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<NewCompanyDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
  }


  public async createCompanyWithNumber() {    
    if (this.customerNumber && this.customerNumber.trim().length > 0) {
      this.isLoading = true;
      var customer = await this.Api.get<OrderCustomerModel>("TurboOrder/GetCustomerByCustomerNo", { customerNo: this.customerNumber, isAxCustomerNumber: true });
      if (customer) {
        var customerInfo = new CustomerInfo();
        customerInfo.OrgNo = customer.OrgNo;
        customerInfo.CompanyName = customer.InvoiceName;
        customerInfo.MobilePhone = customer.MobilePhone ? customer.MobilePhone : customer.Phone;
        customerInfo.Address = customer.InvoiceAddress;
        customerInfo.ZipCode = customer.InvoiceZipCode;
        customerInfo.City = customer.InvoiceCity;
        customerInfo.Email = customer.Mail;
        customerInfo.Type = CustomerType.Company;

        var ret = await this.Api.post<CustomerInfo>("/Rental/SaveCustomer", customerInfo, { isOneWay: false });
        if (ret == null) {
          this.UI.alert("Turbo.NewCompanyDialog.UpdateCustomer.Failed.Headline", "Failed!", "Turbo.NewCompanyDialog.UpdateCustomer.Failed.Message", "The customer information could not be saved. Please try again later.");
        }
        else {
          this.dialogRef.close(ret);
        }
      }
      else {
        await this.UI.alert("Turbo.NewCompanyDialog.hdCustomerNotFound", "Customer not found", "Turbo.NewCompanyDialog.msgCustomerNotFound", "There was no customer found.");
      }
      this.isLoading = false;
    }
    else {
      await this.UI.alert("Turbo.NewCompanyDialog.hdCustomerNumberMandatory", "Customer number required", "Turbo.NewCompanyDialog.msgCustomerNumberMandatory", "Customer number is mandatory.");
    }    
  }
  public async createCompanyManually() {
    this.dialogRef.close(new CustomerInfo());
  }

  public close() {
    this.dialogRef.close(null);
  }

}
